import { Modal } from "antd";
import { UploadChangeParam } from "antd/lib/upload";
import { useState } from "preact/hooks";
import { useMessage } from "../../../hooks/useMessage";
import {
  UPLOAD,
  POST,
  CREATE_MODEL,
  DOWNLOAD,
  UPLOAD_MODEL_EXCEL,
  DOWNLOAD_MODELS_MASTER,
  DOWNLOAD_MODELS_DATA,
  DOWNLOAD_EXAMPLE_IMPORTED_MODEL,
} from "../../../services";
// import { IStateUpload } from "../interfaces/state";

export const useFileExcel = () => {
  const { openMessage } = useMessage();
  const [stateUpload, setStateUpload] = useState([] as any[]);
  const [stateUploadError, setStateUploadError] = useState([] as any[]);
  const [loadingPreviewError, setLoadingPreviewError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isErrorFile, setIsErrorFile] = useState(false);
  const [fileUpload, setFileUpload] = useState([] as any);

  const downloadModelsMaster = async () => {
    setIsLoading(true);
    try {
      const res: any = await DOWNLOAD(DOWNLOAD_MODELS_MASTER);
      const url = window.URL.createObjectURL(new Blob([res]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${"ModelsMaster"}_Data.xlsx`);
      document.body.appendChild(link);

      link.click();
      setIsLoading(false);
    } catch (error: any) {
      setIsLoading(false);
      openMessage(
        "error",
        `เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง ${
          (error && `(${error.message})`) || ""
        }`
      );
    }
  };

  const downloadExampleImportModel = async () => {
    setIsLoading(true);
    try {
      const res: any = await DOWNLOAD(DOWNLOAD_EXAMPLE_IMPORTED_MODEL);
      const url = window.URL.createObjectURL(new Blob([res]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${"exampleImportedModel"}.xlsx`);
      document.body.appendChild(link);

      link.click();
      setIsLoading(false);
    } catch (error: any) {
      setIsLoading(false);
      openMessage(
        "error",
        `เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง ${
          (error && `(${error.message})`) || ""
        }`
      );
    }
  };

  const downloadModelsData = async () => {
    setIsLoading(true);
    try {
      const res: any = await DOWNLOAD(DOWNLOAD_MODELS_DATA);
      const url = window.URL.createObjectURL(new Blob([res]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${"ModelsCorrect"}_Data.xlsx`);
      document.body.appendChild(link);

      link.click();
      setIsLoading(false);
    } catch (error: any) {
      setIsLoading(false);
      openMessage(
        "error",
        `เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง ${
          (error && `(${error.message})`) || ""
        }`
      );
    }
  };

  const onUploadFileExcel = async (data: UploadChangeParam) => {
    setIsLoading(true);
    setLoadingPreviewError(true);
    setFileUpload(data.fileList);
    try {
      if (!data.file || data.file.status === "removed") {
        setFileUpload([]);
        setStateUploadError([]);
        setStateUpload([]);
        setLoadingPreviewError(false);
        setIsLoading(false);
        setIsErrorFile(false);
        return;
      }
      const form = new FormData();
      let errorFile = false;
      form.append("file", data.file as any);
      const res: any = await UPLOAD(UPLOAD_MODEL_EXCEL, form);
      const { models } = res.result;
      const isError = false;
      const newData: any[] = models.map((e: any, i: number) => {
        if (e.error) {
          errorFile = true;
        }
        return {
          ...e,
          index: i + 1,
        };
      });
      if (data.file) {
        const fileType = data.file.name.split(".").pop();
        if (fileType !== "xlsx" && fileType !== "xls") {
          setFileUpload([]);
          setIsLoading(false);
          return Modal.warning({
            title: "กรุณาอัปโหลดไฟล์นามสกุล .xlsx หรือ .xls เท่านั้น",
          });
        }
        setStateUpload(newData);
        setStateUploadError([]);
        setLoadingPreviewError(false);
      }
      setIsErrorFile(errorFile);
    } catch (error: any) {
      setStateUpload([]);
      console.log(error);
      openMessage(
        "error",
        `เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง ${
          (error && `(${error.message})`) || ""
        }`
      );
      setLoadingPreviewError(false);
      setIsErrorFile(true);
    }
    setIsLoading(false);
  };

  const onSaveUploadFileExcel = async (data: any) => {
    try {
      setIsLoading(true);
      const res: any = await POST(CREATE_MODEL, { models: data });
      if (res.success) {
        openMessage("success", res.message);
        setFileUpload([]);
        setStateUpload([]);
      }
      setIsLoading(false);
      return true;
    } catch (error: any) {
      setIsLoading(false);
      openMessage("error", error.message);
    }
  };
  return {
    stateUpload,
    stateUploadError,
    onUploadFileExcel,
    onSaveUploadFileExcel,
    downloadModelsMaster,
    downloadModelsData,
    downloadExampleImportModel,
    loadingPreviewError,
    fileUpload,
    setFileUpload,
    setStateUpload,
    isLoading,
    isErrorFile,
  };
};
